// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9ab74f27","488":"77332fb6","977":"eaef1f19"}[chunkId] + ".chunk.js";
};